import { PlannerRestoreList } from './planner-restore-list';
import { useUser } from '@/components/providers/user-provider';
import { RESTORE_PERMISSIONS } from '@/config/feature-permissions';
import { useEnv } from '@/components/providers/env-provider';
import { hasPermission } from '@/utils/validation';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export function PlannerRestore() {
  const { role } = useUser();
  const { env } = useEnv();
  const navigate = useNavigate();

  useEffect(() => {
    if (!hasPermission(RESTORE_PERMISSIONS[env], role)) {
      navigate('/');
    }
  }, [role, env]);

  return <PlannerRestoreList />;
}
